import { Box } from "@mui/material";
import AdminWordWheelPlay from "./AdminWordWheelPlay";

export default function AdminWordWheelPlayMain() {
    return (
        <Box sx={{ p: 2 }}>
            <AdminWordWheelPlay />
        </Box>
    );
}
